import { Text } from '@chakra-ui/react'
import React from 'react'

import { ConfirmDialog } from '@mangovoice/mango-ui'

import type { SwitchboardTranslateFn } from '../../types'
import { text } from '../../utils/text'

export interface DeleteSwitchboardConfirmationDialogProps {
  isOpen: boolean
  switchboardName?: string
  extensionDialPlan?: number
  onConfirm: () => void
  onCancel: () => void
  t?: SwitchboardTranslateFn
}

/**
 * Confirmation dialog for deleting a switchboard
 */
export const DeleteSwitchboardConfirmationDialog: React.FC<
  DeleteSwitchboardConfirmationDialogProps
> = ({
  isOpen,
  switchboardName,
  extensionDialPlan,
  onConfirm,
  onCancel,
  t,
}) => {
  const bodyMessage = switchboardName
    ? text(
        t,
        'switchboard.dialogs.deleteSwitchboard.bodyWithName',
        'Are you sure you want to delete "{{name}}"?',
        { name: switchboardName },
      )
    : extensionDialPlan
      ? text(
          t,
          'switchboard.dialogs.deleteSwitchboard.bodyWithId',
          'Are you sure you want to delete switchboard {{id}}?',
          { id: extensionDialPlan },
        )
      : text(
          t,
          'switchboard.dialogs.deleteSwitchboard.body',
          'Are you sure you want to delete this switchboard?',
        )

  const warningText = text(
    t,
    'switchboard.dialogs.deleteSwitchboard.warning',
    'This action cannot be undone. All switchboard configuration and data will be permanently deleted.',
  )

  return (
    <ConfirmDialog
      open={isOpen}
      onClose={onCancel}
      title={text(
        t,
        'switchboard.dialogs.deleteSwitchboard.title',
        'Delete Switchboard',
      )}
      description={bodyMessage}
      confirmLabel={text(
        t,
        'switchboard.dialogs.deleteSwitchboard.confirm',
        'Delete',
      )}
      cancelLabel={text(
        t,
        'switchboard.dialogs.deleteSwitchboard.cancel',
        'Cancel',
      )}
      onConfirm={onConfirm}
      variant="destructive"
    >
      <Text fontSize="sm" color="fg.muted" lineHeight="1.5" mt={2}>
        {warningText}
      </Text>
    </ConfirmDialog>
  )
}
